// import dashboardService from "@services/dashboard.service";
import dashboardService from "@services/dashboard.service";
import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import { cloneDeep } from "lodash";
// import moment from "moment";
import React, { useState, useEffect, FC, useCallback } from "react";
import { filterPayload } from "../../calendarUtils";
import DayCard from "../DayCard";

import "./monthCalenderViewPage.scss";

const weekdays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

const MonthCalenderViewPage: FC<any> = () => {
  const _selectedDateCalender = useCalenderViewStore((state) => state.selectedDateCalender);
  const [days, setDays] = useState<any>([]);
  const selectedDateCalender = cloneDeep(_selectedDateCalender);
  const setMonthViewAppointmentData = useCalenderViewStore((state) => state.setMonthViewAppointmentData);
  // const monthViewAppointmentData = useCalenderViewStore((state) => state.monthViewAppointmentData);
  // let localmonthViewAppointmentsContainer = cloneDeep(monthViewAppointmentData);
  const monthFilter = useCalenderViewStore((state) => state.monthFilter);
  const applyFilterFlag = useCalenderViewStore((state) => state.applyFilterFlag);
  const [isMonthDataLoading, setIsMonthDataLoading] = useState(false);
  const isMonthChange = useCalenderViewStore((state) => state.isMonthChange);
  // const setIsMonthChange = useCalenderViewStore((state) => state.setIsMonthChange);

  const loadingNumberOfDays = 31;

  const getMonthViewMasterData = useCallback(() => {
    console.log("MonthCalenderViewPage.getMonthViewMasterData");
    setIsMonthDataLoading(true);
    let startDate = selectedDateCalender.format("YYYY-MM-DD");
    let filters = filterPayload(monthFilter);
    dashboardService.fetchCalenderMonthViewAppointment(startDate, filters).subscribe({
      next: (v) => {
        setMonthViewAppointmentData(v.data.data.result);
        let apointmentdailydata = v.data.data.result;
        const day = selectedDateCalender.date();
        const month = selectedDateCalender.month();
        const year = selectedDateCalender.year();
        // const firstDayOfMonth = selectedDate.startOf("month").format('dddd');
        const daysInMonth = selectedDateCalender.daysInMonth();
        const dateString = selectedDateCalender.startOf("month").format("ddd, MM/DD/YYYY");
        const paddingDays = weekdays.indexOf(dateString.split(", ")[0].toUpperCase());
        const daysArray: any[] = [];

        // apointmentdailydata ? console.log(apointmentdailydata) : console.log("no data yet");

        for (let i = 1; i <= paddingDays + daysInMonth; i++) {
          const dayString = `${month + 1}/${i - paddingDays}/${year}`;
          if (i > paddingDays) {
            daysArray.push({
              value: i - paddingDays,
              isCurrentDay: i - paddingDays === day,
              date: dayString,
              appointments: apointmentdailydata!=="No Data Found" ? apointmentdailydata[i - paddingDays - 1]?.appointmentCount : null,
              new_pts: apointmentdailydata!=="No Data Found" ? apointmentdailydata[i - paddingDays - 1]?.newPatients : null,
              scheduled: apointmentdailydata!=="No Data Found" ? apointmentdailydata[i - paddingDays - 1]?.scheduledAmount : null,
              budget: apointmentdailydata!=="No Data Found" ? apointmentdailydata[i - paddingDays - 1]?.goal : null,
              production: apointmentdailydata!=="No Data Found" ? apointmentdailydata[i - paddingDays - 1]?.production : null,
            });
          } else {
            daysArray.push({
              value: "padding",
              isCurrentDay: false,
              date: "",
            });
          }
        }
        setDays(daysArray);
        setIsMonthDataLoading(false);
      },

      error: (e) => {
        console.log(e);
        setIsMonthDataLoading(false);
      },
    });
  }, [monthFilter, selectedDateCalender, setMonthViewAppointmentData]);

  const getTable = useCallback(() => {
    console.log("MonthCalenderViewPage.getTable"); 
    getMonthViewMasterData();
  }, [getMonthViewMasterData]);

  useEffect(() => {
    console.log("MonthCalenderViewPage.useEffect"); 
    getTable()
  }, [isMonthChange, applyFilterFlag]);

  return (
    <>
      <div className="monthCalender">
        <div className="monthCalender__container">
          <div className="monthCalender__container__weekdays-headers">
            {weekdays.map((dayName, index) => (
              <div key={index}>{dayName}</div>
            ))}
          </div>
          {!isMonthDataLoading ? (
            <div className="monthCalender__container__calendar">
              {days.map((d: any, index: any) => (
                <DayCard key={index} day={d} />
              ))}
            </div>
          ) : (
            <div className="monthCalender__container__calendar">
              {[...Array(loadingNumberOfDays)].map((e, i) => (
              <DayCard key={i} isMonthDataLoading={isMonthDataLoading}/>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default MonthCalenderViewPage;
